
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./text_editor.css";

export default function TextEditor({ value, onChange }) {
  return <ReactQuill value={value} onChange={(value)=>onChange(value)} />;
}
